import {EntityDescriptionModuleTerms} from "../entity-description.module.terms";
import type {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {EntityDescriptionSectionViewModel} from "../../../domain/entity-description/models/section/entity-description.section.view-model";
import {EntityDescriptionFaqElementViewModel} from "./entity-description.faq.element.view-model";
import type {EntityDescriptionElementViewModel} from "../../../domain/entity-description/models/element/entity-description.element.view-model";
import {computed} from "mobx";

export class EntityDescriptionFaqViewModel extends EntityDescriptionSectionViewModel {
  entity: EntityViewModel;
  terms: EntityDescriptionModuleTerms

  constructor(domainModel, entity: EntityViewModel, terms: EntityDescriptionModuleTerms) {
    super(domainModel);

    this.entity = entity;
    this.terms = terms;
  }

  get elementsList(): Array<EntityDescriptionFaqElementViewModel> {
    const answers: Array<EntityDescriptionElementViewModel> = this.answersArray;
    return this.questionsArray?.map(question => {
      const aIndex: Number = answers?.findIndex(a => a.faqId === question.faqId);
      let model: EntityDescriptionFaqElementViewModel = null;

      if (aIndex >= 0) {
        const answer: EntityDescriptionElementViewModel = answers[aIndex];
        answers.splice(aIndex, 1);

        model = new EntityDescriptionFaqElementViewModel(question, answer);
      }

      return model;
    })?.filter((item) => !!item);
  }

  @computed get title(): String {
    const description: String = this.terms.ENTITY_DESCRIPTION_FAQ_HEADER.format({
      ENTITY_NAME: this.entity?.longName || this.entity?.name
    });

    return description;
  }

  get questionsArray() {
    return this.elements?.filter(item => {
      const underscoreNumber = Number(item.isCustomData);
      return this.getSubstringFromEnd(item.name, underscoreNumber).charAt(0) === "Q"
    })
  }

  get answersArray() {
    return this.elements?.filter(item => {
      const underscoreNumber = Number(item.isCustomData);
      return this.getSubstringFromEnd(item.name, underscoreNumber).charAt(0) === "A"
    })
  }

  getSubstringFromEnd(str, underscoreNum): String {
    const parts: Array<String> = str.split('_');
    const startIndex: Number = parts.length - underscoreNum;
    const isOffLimit: Boolean = startIndex <= 0;
    const subString: String = isOffLimit ? str : parts.slice(startIndex - 1).join('_');

    return subString;
  }
}
